import { useEffect, useRef } from "react";

// 🕒 Onglet caché (tour 62, B1). À l'ordinateur, le même délai qu'onglet visible : au bout d'1 h 30 sans retour sur
// l'onglet, une notification « Toujours là ? » et le son, puis hors ligne 5 minutes après sans retour (avant : 1 h 45
// et 2 h). Au téléphone, inchangé (4 et 5 minutes). Les décomptes partent quand l'onglet est caché et s'arrêtent à son
// retour. Ils ne s'arrêtent plus quand la page se redessine : avant, ils étaient dans un effet d'App.js relancé à
// chaque rendu (useIdleTimer renvoie un nouvel objet à chaque rendu, dans les dépendances de l'effet). Un onglet caché
// qui recevait une notification ou un changement du compte ne passait jamais hors ligne.
export const HIDDEN_TAB = {
  desktop: { warnAfter: 90 * 60 * 1000, offlineAfter: 95 * 60 * 1000 },
  mobile: { warnAfter: 4 * 60 * 1000, offlineAfter: 5 * 60 * 1000 },
};

// onWarn et onOffline : les plus récentes, lues au moment où le décompte arrive à son terme
export const useHiddenTabTimers = ({ enabled, isMobile, onWarn, onOffline }) => {
  const callbacks = useRef({ onWarn, onOffline });
  callbacks.current = { onWarn, onOffline };
  useEffect(() => {
    if (!enabled) return;
    const { warnAfter, offlineAfter } = HIDDEN_TAB[isMobile ? "mobile" : "desktop"];
    let timers = [];
    const stop = () => {
      timers.forEach(clearTimeout);
      timers = [];
    };
    const onVisibility = () => {
      if (document.visibilityState !== "hidden") return stop();
      if (timers.length) return;
      timers = [setTimeout(() => callbacks.current.onWarn(), warnAfter), setTimeout(() => callbacks.current.onOffline(), offlineAfter)];
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      stop();
    };
  }, [enabled, isMobile]);
};
